import appSettings from "apps/services/config"
import React from "react"

 export function PackDashBoard() {
    // const URL = appSettings.
    console.log(`'http://143.198.233.137/aquadashboard_app/#/newcard'`);
    
return(
    <>
    <iframe
        src={appSettings.dashboard_url+'/packing-dashboard'}
        // 'http://143.198.233.137/aquadashboard_app/#/newcard'
        title="Example Iframe"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
      ></iframe>
      </>
)
}
export default PackDashBoard